module.exports = __webpack_public_path__ + "static/img/IMG_20240820_120221.9cae78e6.jpg";